// javascript
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './popupmodal.css';

function PopUpModal() {
    const [show, setShow] = useState(false);
    const [btnVisibility, setBtnVisibility] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const whatsappRoutes = [
        '/ERP-implementation-services',
        '/website-development',
        '/hrms'
    ];

    const isWhatsappRoute = whatsappRoutes.includes(location.pathname);
    const handleClose = () => setShow(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setBtnVisibility(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    const handleSendEnquiryClick = () => {
        if (location.pathname.includes('/thankyou')) {
            const originalPath = location.pathname.replace('/thankyou', '') || '/';
            navigate(originalPath, { replace: true });
        } else {
            scrollToTop();
        }
    };

    const RemoveSend = [
        '/web-development-company'
    ];

    const RemoveSendRoute = [
        '/web-design-development',
    ];

    const RemoveSendEnquiry = RemoveSendRoute.includes(location.pathname);
    const FreeQuote = RemoveSendRoute.includes(location.pathname);
    const RemoveButton = RemoveSend.includes(location.pathname);
    const quote = RemoveSend.includes(location.pathname);

    return (
        <div>
            {btnVisibility && !RemoveSendEnquiry && !RemoveButton && (
                <>
                    {isWhatsappRoute ? (
                        /* ===== WhatsApp Button ===== */
                        <a
                            href="https://wa.me/919890452720?text=Hello%20I%20am%20interested%20in%20your%20services"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="popup-btn whatsapp-btn right-align"
                            aria-label="Contact us on WhatsApp"
                            title="Contact us on WhatsApp"
                        >
                            <i
                                className="bi bi-whatsapp"
                                style={{ fontSize: '25px' }}
                                aria-hidden="true"
                            ></i>
                        </a>
                    ) : (
                        /* ===== Send Enquiry Button ===== */
                        <Button
                            className="popup-btn text-white hover:text-white center-align"
                            to={location.pathname}
                            as={Link}
                            onClick={handleSendEnquiryClick}
                            aria-label="Open enquiry form"
                            title="Send enquiry"
                        >
                            SEND ENQUIRY
                        </Button>
                    )}
                </>
            )}

            {FreeQuote && (
                <Button
                    className="updated-style-btn"
                    variant="primary"
                    to={location.pathname}
                    as={Link}
                    onClick={handleSendEnquiryClick}
                    aria-label="Get a free quote for our services"
                >
                    GET A FREE QUOTE
                </Button>
            )}

            {quote && (
                <Button
                    className={`${
                        location.pathname !== '/web-development-company'
                            ? 'updated-style-btn'
                            : 'popup-btn text-white hover:text-white '
                    } ${location.pathname === '/web-development-company' ? 'right-align' : 'center-align'}`}
                    variant="primary"
                    to={location.pathname}
                    as={Link}
                    onClick={handleSendEnquiryClick}
                    aria-label="Free consultation with our experts"
                >
                    FREE CONSULTANT
                </Button>
            )}

            <Modal show={show} onHide={handleClose} aria-labelledby="request-quote-title">
                <Modal.Header closeButton>
                    <Modal.Title id="request-quote-title">Request A Quote</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form
                        className="needs-validation"
                        action="https://formspree.io/f/mwkdlywq"
                        method="POST"
                        noValidate
                    >
                        <div>
                            <label htmlFor="validationName" className="form-label">Your name</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control"
                                id="validationName"
                                maxLength={32}
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor="validationEmail" className="form-label">Your email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                id="validationEmail"
                                pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                                required
                                aria-describedby="emailHelp"
                            />
                        </div>

                        <div>
                            <label htmlFor="validationContact" className="form-label">Contact Number</label>
                            <div className="input-group has-validation">
                                <input
                                    type="tel"
                                    name="contact-number"
                                    className="form-control"
                                    id="validationContact"
                                    aria-describedby="inputGroupPrepend"
                                    maxLength={10}
                                    minLength={10}
                                    pattern="[789][0-9]{9}"
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="validationRequirement" className="form-label">Requirement</label>
                            <div className="input-group has-validation">
                                <textarea
                                    name="requirement"
                                    className="form-control"
                                    id="validationRequirement"
                                    aria-describedby="inputGroupPrepend"
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <button className="btn mt-2 btn-primary" type="submit" aria-label="Submit enquiry form">
                                Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default PopUpModal;
